import PropTypes from 'prop-types'
import React from 'react'
import Draggable from 'react-draggable'
import perMeterCalc from '../../utils/perMeterCalc'
import { SizeContainer } from './theme'

const DraggableProduct = ({ children, perMeter, onStopMove, onMove, isResizing = false, position, index, width, height, aspect = 1, crop, dim}) => {

  const wscale = dim && crop? dim.width/crop.cw:0
  const hscale = dim && crop? dim.height/crop.ch:0

  return (<Draggable
    grid={[perMeterCalc(2, perMeter), perMeterCalc(2, perMeter)]}
    onStart={() => false === isResizing}

    onDrag={(e, data) => onStopMove(index, { x: data.deltaX / wscale, y: data.deltaY / hscale })}
    onStop={(e, data) => onMove(index, { x: data.lastX / wscale, y: data.lastY / hscale })}

    position={position}
  >
    <SizeContainer w={perMeterCalc(width, perMeter)} h={perMeterCalc(height, perMeter)}>
      {children}
    </SizeContainer>
  </Draggable>
)
}
DraggableProduct.propTypes = {
  index: PropTypes.number.isRequired,
  position: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
  }).isRequired,
  children: PropTypes.any.isRequired,
  perMeter: PropTypes.number.isRequired,
  isResizing: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
  onStopMove: PropTypes.func.isRequired,
  onMove: PropTypes.func.isRequired,
}

export default DraggableProduct



// WEBPACK FOOTER //
// ./src/components/DraggableProduct/index.js